
import { Component, Prop, Vue } from "vue-property-decorator";
import { JielongIntroCardDetail } from "@/api/jielong";
// import { downloadUrl } from "@/utils/util";

@Component
export default class PreviewIntroContent extends Vue {
  @Prop({ type: Array, default: () => [] }) details!: JielongIntroCardDetail[];

  // downloadUrl = downloadUrl;
  sftpUrl = "";
  mounted () {
    this.sftpUrl = this.$store.state.user.sftpUrl
  }

  tagList (card: JielongIntroCardDetail): string[] {
    if (!Array.isArray(card.value)) return [];
    return card.value.filter(Boolean) as string[];
  }

  smallImages (card: JielongIntroCardDetail): string[] {
    if (!Array.isArray(card.value)) return [];
    return card.value.filter(Boolean) as string[];
  }

  /** 供父级判断内容是否超出折叠高度 */
  getContentHeight (): number {
    const el = this.$refs.contentRoot as HTMLElement | undefined;
    return el ? el.scrollHeight : 0;
  }
}
